import { render, staticRenderFns } from "./CreateConsequence.vue?vue&type=template&id=24e41676"
import script from "./CreateConsequence.vue?vue&type=script&lang=js"
export * from "./CreateConsequence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports